import { useState,useEffect } from "react";

import {
  Box,
  Collapse,
  IconButton,
  Paper,
  SxProps,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Checkbox,
  Typography
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { faker } from "@faker-js/faker";

const API_URL = `${process.env.REACT_APP_API_URL}`;



export default function ExpandTable() {
  const [open, setOpen] = useState(false);

  const [masterApp,setMasterAppData] = useState([]);
  const [functionData,setFunctionData] = useState([]);

  useEffect(() => {
  
    fetch(`${API_URL}/master_app`,{method: 'get',
    headers: {"Content-Type": "application/json"},
    }).then(response => response.json())
    .then(data => {
       if(data){
        setMasterAppData(data)
       }else{
        console.log(data);
       }
    })
},[])



const handleMasterFunction = (event, name) => {

  const jsonData = {
    app_id :name
  }

    fetch(`${API_URL}/master_app_function`,{method: 'POST',
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify(jsonData)
        }).then(response => response.json())
        .then(data => {
          if(data){
            setFunctionData(data)
          }else{
            console.log(data);
          }
    })
  


}

console.log(functionData);

  return (
    <TableContainer component={Paper} >
      <Table>
        <TableHead>
          <TableRow >
            <TableCell>APP NAME</TableCell>
            <TableCell/>
           
          </TableRow>
        </TableHead>
        <TableBody>
          {masterApp.map((row, index) => (
            <>
              <TableRow key={row.app_id} onClick={(event) => handleMasterFunction(event, row.app_id)}>
                <TableCell>
                  <IconButton
                    aria-label="expand row"
                    size="small"
                    onClick={() => setOpen(open === index ? -1 : index)}
                  >
                    {open === index ? (
                      <KeyboardArrowUpIcon />
                    ) : (
                      <KeyboardArrowDownIcon />
                    )}
                  </IconButton>
                </TableCell>
                <TableCell>{row.app_name}</TableCell>
               
              </TableRow>
              <TableRow >
                <TableCell colSpan={5} sx={{ paddingBottom: 0, paddingTop: 0, border: '0px'}}>
                  <Collapse in={open === index} timeout="auto" unmountOnExit >
                 
                    <Box sx={{ margin: 1 }}>
                      <Typography variant="h6" gutterBottom component="div">
                          {row.app_name}
                        </Typography>
                        <Table size="small" aria-label="purchases">
                          <TableHead>
                            <TableRow>
                              <TableCell>Function Name</TableCell>
                              <TableCell>Add</TableCell>
                              <TableCell>Edit</TableCell>
                              <TableCell>Delete</TableCell>
                              <TableCell>Approve</TableCell>
                              <TableCell>Print/Export</TableCell>
                              <TableCell>Upload</TableCell>
                              <TableCell>ALL</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {functionData.map((rows,index) => {
                              return (
                              <TableRow key={rows.function_id}>
                                <TableCell component="th" scope="row">
                                  {rows.function_name}
                                </TableCell>
                                <TableCell>
                                    <Checkbox/>
                                </TableCell>
                                <TableCell>
                                    <Checkbox/>
                                </TableCell>
                                <TableCell>
                                    <Checkbox/>
                                </TableCell>
                                <TableCell>
                                    <Checkbox/>
                                </TableCell>
                                <TableCell>
                                    <Checkbox/>
                                </TableCell>
                                <TableCell>
                                    <Checkbox/>
                                </TableCell>
                                <TableCell>
                                    <Checkbox/>
                                </TableCell>

                              </TableRow>
                              )
                            })}
                          </TableBody>
                        </Table>
                    </Box>
                  </Collapse>
                </TableCell>
              </TableRow>
            </>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}